import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataPostingSymbol } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_POSTING_SYMBOL =
  defineMasterdataEntity<MasterdataPostingSymbol>({
    name: 'posting-symbol',
    responseKey: 'postingSymbols',
    displayWith: (s) => keyName(s.key, s.name),
    icon: 'fa-regular fa-hashtag',
    title: 'Buchungssymbolsuche',
    label: 'Buchungssymbol',
    placeholder: 'Buchungssymbol suchen...',
    columns: [
      {
        label: 'Buchungssymbol',
        type: 'entity',
        icon: 'fa-regular fa-hashtag',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    ],
  });
